import { render, staticRenderFns } from "./wishlist-header.vue?vue&type=template&id=7a759d57"
import script from "./wishlist-header.vue?vue&type=script&lang=js"
export * from "./wishlist-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports